import { Component, Output, EventEmitter, OnInit, Inject, OnDestroy } from '@angular/core';
import { NotificacionsFilter } from '../../models/notificacions-filter';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { Observable, Subscription } from 'rxjs';

@Component({
    selector: 'app-notificacions-filter',
    templateUrl: 'notificacions-filter.component.html',
    styleUrls: ['notificacions-filter.component.scss']
})
export class NotificacionsFilterComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  filter: NotificacionsFilter;

  @Output() notify: EventEmitter<NotificacionsFilter> = new EventEmitter<NotificacionsFilter>();

  constructor(
    public thisDialogRef: MatDialogRef<NotificacionsFilterComponent>,
    private i18n: I18n,
    @Inject(MAT_DIALOG_DATA) public data) {
    this.filter = data;
  }

  ngOnInit() {
    this.subscription = Observable.fromEvent(document, 'keypress').subscribe((e: KeyboardEvent ) => {
      if (e.key === 'Enter') {
        this.apply();
      }
    });
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  reset() {
    this.filter.clear();
    this.apply();
  }

  apply() {
    this.filter.updated();
    this.notify.emit(this.filter);
    this.thisDialogRef.close();
  }

  dismiss() {
    this.thisDialogRef.close();
  }

}
